import React from "react";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { DashlyFilterClearField } from "../DashlyFilterClearField/DashlyFilterClearField";
import { DashlyControlSize } from "../shared/dashlyControlSize";
import { DashlyTextInput } from "../DashlyTextInput/DashlyTextInput";

export type DashlyFilterSearchProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    inputId?: string;
    /** PrimeIcons class at the start of the field. Default `pi pi-search`. */
    leadingIcon?: string;
    /** Control height scale. Default `md`. */
    controlSize?: DashlyControlSize;
};

export const DashlyFilterSearch: React.FC<DashlyFilterSearchProps> = ({
    value,
    onChange,
    placeholder,
    className,
    disabled = false,
    inputId,
    leadingIcon = "pi pi-search",
    controlSize = "md",
}) => {
    const { t } = useTranslation();
    const hasValue = Boolean(value?.trim());
    const clearLabel = t("common.action.clear_filter");

    return (
        <div className={classNames("dashly-filter-search", className)}>
            <DashlyFilterClearField
                hasValue={hasValue}
                onClear={() => onChange("")}
                clearLabel={clearLabel}
                controlType="text"
            >
                <DashlyTextInput
                    id={inputId}
                    controlVariant="filter"
                    controlSize={controlSize}
                    leadingIcon={leadingIcon}
                    value={value}
                    disabled={disabled}
                    placeholder={placeholder}
                    className="w-full"
                    onChange={(event) => onChange(event.target.value)}
                />
            </DashlyFilterClearField>
        </div>
    );
};
